module.exports = __webpack_public_path__ + "img/Drive shaft assembly.8d958d5b.jpg";